import colors from "../theme";
export const timePickerSx = {
  width: "8rem",
  marginTop: 3,
  "& .MuiOutlinedInput-root": {
    "&:hover fieldset": {
      borderColor: colors.secondary,
    },
    "&.Mui-focused fieldset": {
      borderColor: colors.secondary,
    },
  },
  "& .MuiInputLabel-root": {
    "&.Mui-focused": {
      color: colors.secondary,
    },
  },
};

export const timePickerSlotProps = {
  textField: { size: "small" },
  actionBar: {
    sx: {
      "& .MuiButtonBase-root": {
        color: colors.secondary,
        "&:hover": {
          backgroundColor: colors.secondary,
          color: "white",
        },
      },
    },
  },
  layout: {
    sx: {
      backgroundColor: colors.mainContentBgColor,
      "& .MuiPickersArrowSwitcher-root": {
        display: "none !important",
      },
      "& .MuiClock-pin": {
        backgroundColor: colors.secondary,
      },
      "& .MuiClockPointer-root": {
        backgroundColor: colors.secondary,
      },
      "& .MuiClockPointer-thumb": {
        backgroundColor: colors.secondary,
        border: `16px solid ${colors.secondary}`,
      },
      "& .MuiClockNumber-root.Mui-selected": {
        backgroundColor: colors.secondary,
      },
    },
  },
  leftArrowIcon: {
    sx: {
      color: colors.secondary,
    },
  },
  rightArrowIcon: {
    sx: {
      color: colors.secondary,
    },
  },
};
